module.exports = __webpack_public_path__ + "static/media/steal.76105c9f.svg";